<template>
    <!--
        Flash component.
        Displays content inside a layer above the page content.
        Closable by clicking button background-layer or pressing esc-key
    -->
    <div class="flash">
        <transition name="fade">
            <div class="flash-background" @click="close" v-if="show"></div>
        </transition>

        <transition name="slide-top">
            <div class="flash-content" v-if="show">

                <div class="head" v-if="headline !== ''">
                    <h2 v-html="headline"></h2>
                </div>

                <div v-if="content" class="body" v-html="content"></div>
            </div>
        </transition>
    </div>
</template>

<script>
import events from '../../events/events';

export default
{
    name: 'Flash',

    data() {
        return {
            show: false,
            headline: '',
            content: '',
            callback: null,
        }
    },

    created()
    {
        /**
         * Open flash dialog.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        events.$on('flash.open', (headline, content, callback) => {
            this.headline = headline || '';
            this.content = content;
            this.callback = callback;

            this.show = true;

            window.addEventListener('keyup', this.closeEsc, false);
        });
    },

    methods:
    {
        /**
         * Close dialog and remove event listener from window
         */
        close() {
            window.removeEventListener('keyup', this.closeEsc, false);
            this.show = false;
            if (typeof this.callback == 'function') this.callback();

            this.headline = '';
            this.content = '';
            this.callback = null;
        },

        /**
         * Triggers close method
         *
         * @param {Object} e
         */
        closeEsc(e) {
            if (e.keyCode === 27) {
                this.close();
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// Flash.vue?7ea5a3e4